


// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box, Grid, Typography, Chip, CircularProgress,
//   Alert, Avatar, IconButton, Tooltip, CssBaseline,
// } from "@mui/material";
// import {
//   Work, CheckCircle, TrendingUp, NewReleases,
//   FiberManualRecord, Business, AssignmentInd, Groups,
//   Engineering, AccessTime, Domain, SupervisorAccount,
//   ArrowUpward, ArrowDownward, Refresh,
//   Dashboard as DashboardIcon, PersonOutline, BadgeOutlined, Assessment,
//   AccountCircle as AccountCircleIcon, ExitToApp as ExitToAppIcon,
//   Notifications as NotificationsIcon, Business as BusinessIcon, Assessment as AssessmentIcon,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import styled, { keyframes, createGlobalStyle } from "styled-components";
// import axios from "axios";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RTooltip,
//   Legend, ResponsiveContainer, PieChart, Pie, Cell,
// } from "recharts";
// import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
// import BenchPeople       from "../HRPages/BenchPeople/Benchpeople.js";
// import Employees         from "../HRPages/EmployeePages/EmployeesPage.js";
// import ProfileForm       from "../shared/Profileform.js";
// import ClientManagement  from "../HiringManager/Clientmanagement.js";
// import AllClientsAnalytics from "../ManagerPages/ClientManagement/ClientAnalytics.js";
// import RbotManagerDashboard from "./RbotManagerDashboard.js";
// import CandidateBrowserPage from "./CandidateManagement/Candidatebrowserpage.js";
// import ClientSummaryReport from "../Reports/ClientSummaryReport.js";


// // ─── Globals ──────────────────────────────────────────────────────────────────
// const GlobalStyle = createGlobalStyle`
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Syne:wght@400;500;600;700;800&display=swap');
//   * { box-sizing: border-box; margin: 0; padding: 0; }
//   ::-webkit-scrollbar { width: 5px; height: 5px; }
//   ::-webkit-scrollbar-track { background: transparent; }
//   ::-webkit-scrollbar-thumb { background: rgba(103,80,164,0.2); border-radius: 99px; }
// `;

// const fadeUp = keyframes`
//   from { opacity: 0; transform: translateY(12px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// // ─── Layout shell ─────────────────────────────────────────────────────────────
// const Shell = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background: #EDEAF5;
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   padding-top: 68px;
// `;

// const AppBar = styled.header`
//   position: fixed;
//   top: 0; left: 0; right: 0;
//   height: 68px;
//   background: rgba(255,255,255,0.98);
//   backdrop-filter: blur(20px);
//   border-bottom: 1px solid rgba(103,80,164,0.10);
//   box-shadow: 0 2px 16px rgba(55,30,110,0.07);
//   z-index: 1300;
//   display: flex;
//   align-items: center;
//   padding: 0 24px;
//   justify-content: space-between;
// `;

// const Brand = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 14px;
//   padding-right: 24px;
//   border-right: 1.5px solid rgba(103,80,164,0.10);
// `;

// const BrandLogo = styled.div`
//   width: 44px; height: 44px;
//   border-radius: 13px;
//   background: linear-gradient(135deg, #EDE7F6, #D0BCFF);
//   border: 1.5px solid rgba(103,80,164,0.16);
//   display: flex; align-items: center; justify-content: center;
//   box-shadow: 0 3px 12px rgba(79,55,139,0.14);
//   flex-shrink: 0;
// `;

// const BrandName = styled.div`
//   font-family: 'Syne', sans-serif;
//   font-weight: 800;
//   font-size: 21px;
//   background: linear-gradient(135deg, #2D1B5E 0%, #6750A4 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   background-clip: text;
//   letter-spacing: -0.5px;
//   line-height: 1;
//   white-space: nowrap;
// `;

// const BrandSub = styled.div`
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   font-size: 10px;
//   font-weight: 700;
//   color: #9B8DC4;
//   letter-spacing: 1.4px;
//   text-transform: uppercase;
//   margin-top: 3px;
// `;

// const UserPill = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   background: linear-gradient(135deg, #F6F2FF, #EDE7F6);
//   border: 1px solid rgba(103,80,164,0.13);
//   border-radius: 36px;
//   padding: 5px 14px 5px 5px;
//   white-space: nowrap;
// `;

// const UserAvatar = styled.div`
//   width: 36px; height: 36px;
//   border-radius: 50%;
//   background: linear-gradient(135deg, #7C5CBF, #4F378B);
//   color: #fff;
//   font-family: 'Syne', sans-serif;
//   font-weight: 700;
//   font-size: 13px;
//   display: flex; align-items: center; justify-content: center;
//   box-shadow: 0 2px 8px rgba(79,55,139,0.3);
//   flex-shrink: 0;
// `;

// const BellBtn = styled.button`
//   width: 40px; height: 40px;
//   background: linear-gradient(135deg, #F3EEF9, #E8DEF8);
//   border: none; border-radius: 11px;
//   display: flex; align-items: center; justify-content: center;
//   cursor: pointer; transition: all 0.18s; flex-shrink: 0;
//   &:hover { background: linear-gradient(135deg, #E8DEF8, #D0BCFF); transform: scale(1.06); }
//   svg { color: #5A40A0; font-size: 21px; }
// `;

// // ─── Sidebar ──────────────────────────────────────────────────────────────────
// const Sidebar = styled.nav`
//   width: 240px;
//   min-width: 240px;
//   flex-shrink: 0;
//   background: linear-gradient(168deg, #1E1245 0%, #3D2A7A 52%, #6750A4 100%);
//   height: calc(100vh - 68px);
//   position: sticky;
//   top: 0;
//   display: flex;
//   flex-direction: column;
//   padding: 16px 10px 20px;
//   overflow-y: auto;
//   box-shadow: 4px 0 28px rgba(55,30,110,0.22);
//   z-index: 10;
// `;

// const SidebarSection = styled.div`
//   margin-top: 16px;
// `;

// const SidebarSectionLabel = styled.div`
//   font-size: 9.5px;
//   font-weight: 700;
//   letter-spacing: 2px;
//   text-transform: uppercase;
//   color: rgba(255,255,255,0.35);
//   padding: 0 10px;
//   margin-bottom: 5px;
// `;

// const NavItem = styled.button`
//   width: 100%;
//   background: ${p => p.$active ? "rgba(255,255,255,0.16)" : "transparent"};
//   border: none;
//   border-radius: 10px;
//   padding: 9px 12px;
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   color: ${p => p.$active ? "#fff" : "rgba(255,255,255,0.70)"};
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   font-size: 13px;
//   font-weight: ${p => p.$active ? 700 : 500};
//   cursor: pointer;
//   transition: all 0.16s;
//   margin-bottom: 2px;
//   text-align: left;
//   outline: none;
//   position: relative;
//   &:hover { background: rgba(255,255,255,0.11); color: #fff; }
//   svg { font-size: 18px; flex-shrink: 0; }
//   &::before {
//     content: '';
//     position: absolute;
//     left: 0; top: 20%; bottom: 20%;
//     width: 3px;
//     border-radius: 0 3px 3px 0;
//     background: #D0BCFF;
//     opacity: ${p => p.$active ? 1 : 0};
//     transition: opacity 0.16s;
//   }
// `;

// const SidebarDivider = styled.div`
//   height: 1px;
//   background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
//   margin: 12px 0;
// `;

// // ─── Main content area ────────────────────────────────────────────────────────
// const Main = styled.main`
//   flex: 1;
//   min-width: 0;
//   overflow-y: auto;
//   height: calc(100vh - 68px);
//   background: #EDEAF5;
// `;

// const DashPane = styled.div`
//   padding: 24px 28px 48px;
//   animation: ${fadeUp} 0.34s ease both;
// `;

// const SubPagePane = styled.div`
//   padding: 24px 28px 48px;
//   animation: ${fadeUp} 0.34s ease both;
// `;

// // ─── Section label ────────────────────────────────────────────────────────────
// const SectionLabel = ({ children }) => (
//   <Typography sx={{
//     fontSize: 10, fontWeight: 700, color: "#8A85A8",
//     textTransform: "uppercase", letterSpacing: "0.12em",
//     mb: 1, mt: 0.5, fontFamily: "Plus Jakarta Sans",
//   }}>
//     {children}
//   </Typography>
// );

// // ─── Metric tile — fixed layout with no overflow ──────────────────────────────
// const MetricTile = ({ icon, value, label, accentColor, accentBg, trendPct, trendUp }) => (
//   <Box sx={{
//     flex: "1 1 0",
//     minWidth: 0,                   // crucial: let flex shrink freely
//     background: "#fff",
//     border: "0.5px solid rgba(0,0,0,0.07)",
//     borderRadius: "13px",
//     p: "14px 16px",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     transition: "box-shadow 0.16s, transform 0.16s",
//     "&:hover": { boxShadow: "0 4px 20px rgba(79,55,139,0.10)", transform: "translateY(-1px)" },
//   }}>
//     {/* Icon */}
//     <Box sx={{
//       width: 36, height: 36, borderRadius: "9px",
//       background: accentBg, flexShrink: 0,
//       display: "flex", alignItems: "center", justifyContent: "center",
//     }}>
//       {React.cloneElement(icon, { sx: { fontSize: 18, color: accentColor } })}
//     </Box>

//     {/* Text — takes remaining space, clips if needed */}
//     <Box sx={{ minWidth: 0, flex: 1 }}>
//       <Typography sx={{
//         fontFamily: "Syne", fontWeight: 800, fontSize: 20,
//         color: "#1a1a1a", lineHeight: 1, fontVariantNumeric: "tabular-nums",
//       }}>
//         {value ?? "—"}
//       </Typography>
//       <Typography sx={{
//         fontSize: 11, fontWeight: 500, color: "#7A6FA0",
//         mt: "3px", lineHeight: 1.2,
//         overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
//       }}>
//         {label}
//       </Typography>
//     </Box>

//     {/* Trend pill — only shown when provided */}
//     {trendPct != null && (
//       <Box sx={{
//         display: "flex", alignItems: "center", gap: "2px",
//         background: trendUp ? "#E1F5EE" : "#FCEBEB",
//         borderRadius: "20px", px: "7px", py: "3px",
//         flexShrink: 0,
//       }}>
//         {trendUp
//           ? <ArrowUpward sx={{ fontSize: 9, color: "#0F6E56" }} />
//           : <ArrowDownward sx={{ fontSize: 9, color: "#A32D2D" }} />}
//         <Typography sx={{ fontSize: 10, fontWeight: 700, color: trendUp ? "#0F6E56" : "#A32D2D", lineHeight: 1 }}>
//           {trendPct}%
//         </Typography>
//       </Box>
//     )}
//   </Box>
// );

// // ─── Metric row — flex container that never wraps (scrolls on tiny screens) ──
// const MetricRow = styled.div`
//   display: flex;
//   gap: 10px;
//   margin-bottom: 20px;
//   /* allow overflow scroll on very narrow screens instead of ugly wrap */
//   overflow-x: auto;
//   padding-bottom: 2px;
// `;

// // ─── Chart card ───────────────────────────────────────────────────────────────
// const ChartCard = styled.div`
//   background: #fff;
//   border: 0.5px solid rgba(0,0,0,0.07);
//   border-radius: 14px;
//   overflow: hidden;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
// `;

// const ChartHeader = styled.div`
//   padding: 14px 18px 11px;
//   border-bottom: 0.5px solid rgba(0,0,0,0.06);
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 10px;
//   flex-shrink: 0;
// `;

// const ChartTitle = styled.div`
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   font-size: 13px;
//   font-weight: 700;
//   color: #1a1a1a;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// `;

// const ChartBadge = styled.span`
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   font-size: 11px;
//   font-weight: 600;
//   background: ${p => p.$bg || "#F1EFE8"};
//   color: ${p => p.$color || "#5F5E5A"};
//   border-radius: 20px;
//   padding: 2px 10px;
//   white-space: nowrap;
//   flex-shrink: 0;
// `;

// const ChartBody = styled.div`
//   padding: 14px 14px 12px;
//   flex: 1;
// `;

// // ─── Horizontal bar row ───────────────────────────────────────────────────────
// const HBar = ({ label, count, maxCount, color, bg, pct }) => (
//   <Box mb={1.5}>
//     <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.4}>
//       <Box display="flex" alignItems="center" gap={0.8} sx={{ minWidth: 0, flex: 1, mr: 1 }}>
//         <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: color, flexShrink: 0 }} />
//         <Typography sx={{
//           fontSize: 12, color: "#2C2C2A", fontFamily: "Plus Jakarta Sans",
//           overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
//         }}>
//           {label}
//         </Typography>
//       </Box>
//       <Box display="flex" alignItems="center" gap={1} flexShrink={0}>
//         {pct !== undefined && (
//           <Typography sx={{ fontSize: 10.5, color: "#C0BDB5", fontVariantNumeric: "tabular-nums" }}>{pct}%</Typography>
//         )}
//         <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "#1a1a1a", minWidth: 22, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
//           {count}
//         </Typography>
//       </Box>
//     </Box>
//     <Box sx={{ height: 5, borderRadius: 99, bgcolor: bg, overflow: "hidden" }}>
//       <Box sx={{ width: `${maxCount > 0 ? (count / maxCount) * 100 : 0}%`, height: "100%", bgcolor: color, borderRadius: 99, transition: "width 0.4s ease" }} />
//     </Box>
//   </Box>
// );

// const Empty = ({ msg }) => (
//   <Box py={4} textAlign="center">
//     <Typography sx={{ fontSize: 12, color: "#C0BDB5", fontFamily: "Plus Jakarta Sans" }}>{msg}</Typography>
//   </Box>
// );

// // ─── Priority meta ────────────────────────────────────────────────────────────
// const PRIORITY_META = {
//   Critical: { bg: "#FCEBEB", color: "#791F1F", dot: "#E24B4A", border: "#F09595" },
//   High:     { bg: "#FAEEDA", color: "#633806", dot: "#EF9F27", border: "#FAC775" },
//   Medium:   { bg: "#E6F1FB", color: "#0C447C", dot: "#378ADD", border: "#B5D4F4" },
// };

// const STAGE_COLORS = ["#5A40A0","#0F6E56","#185FA5","#854F0B","#A32D2D","#993556"];
// const STAGE_BGS    = ["#EDE9F7","#E1F5EE","#E6F1FB","#FAEEDA","#FCEBEB","#FBEAF0"];
// const DEPT_COLORS  = ["#185FA5","#0F6E56","#854F0B","#534AB7","#993C1D","#993556","#3B6D11","#5F5E5A"];
// const DEPT_BGS     = ["#E6F1FB","#E1F5EE","#FAEEDA","#EEEDFE","#FAECE7","#FBEAF0","#EAF3DE","#F1EFE8"];

// const BENCH_COLORS = {
//   "Available":      { c: "#0F6E56", bg: "#E1F5EE" },
//   "On Project":     { c: "#185FA5", bg: "#E6F1FB" },
//   "Notice Period":  { c: "#854F0B", bg: "#FAEEDA" },
//   "Pending Review": { c: "#534AB7", bg: "#EEEDFE" },
//   "Inactive":       { c: "#5F5E5A", bg: "#F1EFE8" },
// };

// // ─── Recharts tooltip ─────────────────────────────────────────────────────────
// const CustomTooltip = ({ active, payload, label }) => {
//   if (!active || !payload?.length) return null;
//   return (
//     <div style={{
//       background: "#fff", border: "0.5px solid rgba(0,0,0,0.10)",
//       borderRadius: 10, padding: "10px 14px",
//       boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//       fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 12,
//     }}>
//       {label && <div style={{ fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{label}</div>}
//       {payload.map((p, i) => (
//         <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, color: "#444", marginTop: 2 }}>
//           <span style={{ width: 8, height: 8, borderRadius: "50%", background: p.color, display: "inline-block", flexShrink: 0 }} />
//           <span>{p.name}:</span>
//           <span style={{ fontWeight: 700, color: "#1a1a1a" }}>{p.value}</span>
//         </div>
//       ))}
//     </div>
//   );
// };

// // ─── API helpers ──────────────────────────────────────────────────────────────
// const API_URL  = process.env.REACT_APP_API_BASE_URL;
// const getToken = () => localStorage.getItem("token") || "";

// const authFetch = async (url) => {
//   const res = await fetch(url, {
//     headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
//   });
//   if (res.status === 401) { localStorage.clear(); window.location.href = "/login"; }
//   return res;
// };

// const statusCount = (arr = [], key) => arr.find((s) => s._id === key)?.count ?? 0;

// // ─── Period config ────────────────────────────────────────────────────────────
// const PERIODS = [
//   { label: "7d",  value: "week"    },
//   { label: "30d", value: "month"   },
//   { label: "90d", value: "quarter" },
//   { label: "Custom", value: "custom" },
// ];

// // ═════════════════════════════════════════════════════════════════════════════
// export default function ManagerDashboard() {
//   const navigate = useNavigate();

//   const user = (() => {
//     try { return JSON.parse(localStorage.getItem("user") || "{}"); }
//     catch { return {}; }
//   })();
//   const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "Manager";
//   const initials  = `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase() || "MG";
//   const logoutApiUrl = process.env.REACT_APP_LOGOUT_API;

//   const [activeTab, setActiveTab] = useState("dashboard");
//   const [period,    setPeriod]    = useState("month");
//   const [customStart, setCustomStart] = useState(new Date().toISOString().split("T")[0]);
//   const [customEnd,   setCustomEnd]   = useState(new Date().toISOString().split("T")[0]);

//   const [portal,     setPortal]     = useState(null);
//   const [rbot,       setRbot]       = useState(null);
//   const [benchStats, setBenchStats] = useState(null);
//   const [benchTotal, setBenchTotal] = useState(null);
//   const [empStats,   setEmpStats]   = useState(null);
//   const [empTotal,   setEmpTotal]   = useState(null);
//   const [loading,    setLoading]    = useState(true);
//   const [error,      setError]      = useState("");
// const [candidateBrowserCompany, setCandidateBrowserCompany] = useState(null);
//   const fetchDashboard = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//     const periodParam = period === "custom" && customStart && customEnd
//       ? `custom&start=${customStart}&end=${customEnd}`
//       : period;

//     const [pR, rR, bsR, blR, esR, elR] = await Promise.all([
//       authFetch(`${API_URL}/dashboard/`),
//       authFetch(`${API_URL}/rbot-dashboard/manager?period=${periodParam}`),
//       authFetch(`${API_URL}/bench/stats`),
//       authFetch(`${API_URL}/bench/?page=1&per_page=1`),
//       authFetch(`${API_URL}/employees/stats`),
//       authFetch(`${API_URL}/employees/?page=1&per_page=1`),
//     ]);
//       // const [pR, rR, bsR, blR, esR, elR] = await Promise.all([
//       //   authFetch(`${API_URL}/dashboard/`),
//       //   authFetch(`${API_URL}/rbot-dashboard/manager?period=${period}`),
//       //   authFetch(`${API_URL}/bench/stats`),
//       //   authFetch(`${API_URL}/bench/?page=1&per_page=1`),
//       //   authFetch(`${API_URL}/employees/stats`),
//       //   authFetch(`${API_URL}/employees/?page=1&per_page=1`),
//       // ]);
//       const [pJ, rJ, bsJ, blJ, esJ, elJ] = await Promise.all([
//         pR.json(), rR.json(), bsR.json(), blR.json(), esR.json(), elR.json(),
//       ]);
//       if (pJ.success)  setPortal(pJ.dashboard ?? {});
//       if (rJ.success)  setRbot(rJ);
//       if (bsJ.success) setBenchStats(bsJ.data ?? {});
//       if (blJ.success) setBenchTotal(blJ.total ?? 0);
//       if (esJ.success) setEmpStats(esJ.data ?? {});
//       if (elJ.success) setEmpTotal(elJ.total ?? 0);
//     } catch {
//       setError("Unable to load dashboard data. Please refresh.");
//     } finally {
//       setLoading(false);
//     }
//   }, [period, customStart, customEnd]);

//   useEffect(() => {
//     if (activeTab === "dashboard") fetchDashboard();
//   }, [fetchDashboard, activeTab]);

//   const handleLogout = async () => {
//     try {
//       const userEmail = user?.email;
//       const tokens = JSON.parse(localStorage.getItem("userTokens") || "{}");
//       const token  = userEmail ? tokens[userEmail] : null;
//       if (token && logoutApiUrl) {
//         await axios.post(logoutApiUrl, { token, email: userEmail }, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         delete tokens[userEmail];
//         localStorage.setItem("userTokens", JSON.stringify(tokens));
//         localStorage.setItem('token',null)

//       }
//     } catch (err) { console.error(err); }
//           navigate('/login',{ replace: true });
//   };
// const handleViewClientJobs = (client) => {
//   setCandidateBrowserCompany(client.company_name);
//   setActiveTab("candidateProfiles");
// };

// const handleCandidateProfilesTab = () => {
//   setCandidateBrowserCompany(null);
//   setActiveTab("candidateProfiles");
// };
//   // ── Derived ───────────────────────────────────────────────────────────────
//   const stageCounts  = portal?.stage_counts       ?? [];
//   const highJobs     = portal?.high_priority_jobs ?? [];
//   const rbKpis       = rbot?.kpis                 ?? {};
//   const rbRecruiters = (rbot?.recruiter_breakdown ?? [])
//     .filter(r => r.recruiter_id !== "Other" && r.recruiter_name !== "Other").slice(0, 6);
//   const rbJdOverall  = (rbot?.jd_overall ?? []).slice(0, 6);

//   const benchByStatus  = benchStats?.by_status ?? [];
//   const benchAvailable = statusCount(benchByStatus, "Available");
//   const benchOnProject = statusCount(benchByStatus, "On Project");
//   const benchNotice    = statusCount(benchByStatus, "Notice Period");
//   const benchOther     = Math.max(0, (benchTotal ?? 0) - benchAvailable - benchOnProject - benchNotice);
//   const benchMaxCount  = Math.max(1, ...benchByStatus.map(s => s.count));

//   const empByStatus      = empStats?.by_status     ?? [];
//   const empByDept        = empStats?.by_department ?? [];
//   const empActive        = statusCount(empByStatus, "Active");
//   const empActiveClients = empStats?.active_clients ?? 0;
//   const empMaxDept       = Math.max(1, ...empByDept.map(d => d.count));

//   const stageTotal = stageCounts.reduce((s, x) => s + x.count, 0);
//   const maxRbRec   = Math.max(1, ...rbRecruiters.map(r => r.selected));

//   const hour     = new Date().getHours();
//   const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

//   // const currentPeriodLabel = PERIODS.find(p => p.value === period)?.label ?? "30d";
//   const currentPeriodLabel = period === "custom" && customStart && customEnd
//   ? `${customStart} → ${customEnd}`
//   : PERIODS.find(p => p.value === period)?.label ?? "30d";

//   // chart data
//   const pipelineDonutData = stageCounts.map((s, i) => ({
//     name: s.stage, value: s.count, color: STAGE_COLORS[i % STAGE_COLORS.length],
//   }));

//   const recruiterBarData = rbRecruiters.map(r => ({
//     name:     (r.recruiter_name || "?").split(" ")[0],
//     Selected: r.selected ?? 0,
//     Rejected: r.rejected ?? 0,
//     Active:   Math.max(0, (r.total ?? 0) - (r.selected ?? 0) - (r.rejected ?? 0)),
//   }));

//   const dailyIntake    = (rbot?.daily_breakdown ?? []).slice(-14).map(d => ({
//     date: d.date ? new Date(d.date).toLocaleDateString("en-IN", { day: "numeric", month: "short" }) : d.label,
//     ...Object.fromEntries((d.recruiters ?? []).map(r => [(r.name || "?").split(" ")[0], r.count ?? 0])),
//     Total: d.total ?? 0,
//   }));
//   const recruiterNames = [...new Set(rbRecruiters.map(r => (r.recruiter_name || "?").split(" ")[0]))];

//   // ─── Sidebar nav ──────────────────────────────────────────────────────────
//   const nav = [
//     {
//       section: "Overview",
//       items: [
//         { id: "dashboard",          icon: <DashboardIcon />,     label: "Dashboard"        },
//         { id: "allclientanalytics", icon: <BusinessIcon />,      label: "Client Analytics" },
//         { id: "recruiterreports",   icon: <Assessment />,        label: "Team Analytics"   },
//       ],
//     },
//     {
//       section: "Manage",
//       items: [
//         { id: "clients",    icon: <BusinessIcon />,  label: "Clients"      },
//         { id: "benchPeople",icon: <PersonOutline />, label: "Bench People" },
//         { id: "employees",  icon: <BadgeOutlined />, label: "Employees"    },
//         { id: "candidateProfiles",  icon: <RecentActorsOutlinedIcon />, label: "Candidate Profiles"    },
//         { id: "summary",  icon: <AssessmentIcon />, label: "Summary Report"    },

        
//       ],
//     },
//     {
//       section: "Account",
//       items: [
//         { id: "profile", icon: <AccountCircleIcon />, label: "Profile" },
//       ],
//     },
//   ];

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <GlobalStyle />
//       <CssBaseline />
//       <Shell>

//         {/* ══ AppBar ════════════════════════════════════════════════════════ */}
//         <AppBar>
//           <Brand>
//             <BrandLogo>
//               <AssignmentInd sx={{ color: "#6750A4", fontSize: 26 }} />
//             </BrandLogo>
//             <div>
//               <BrandName>Resourcing Bot</BrandName>
//               <BrandSub>Manager Portal</BrandSub>
//             </div>
//           </Brand>

//           <Box display="flex" alignItems="center" gap="12px">
//             <BellBtn><NotificationsIcon /></BellBtn>
//             <UserPill>
//               <UserAvatar>{initials}</UserAvatar>
//               <div>
//                 <Typography sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: 700, fontSize: 13, color: "#2D1B5E", lineHeight: 1.2 }}>
//                   {fullName}
//                 </Typography>
//                 <Typography sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: 500, fontSize: 10.5, color: "#9B8DC4" }}>
//                   Manager
//                 </Typography>
//               </div>
//             </UserPill>
//           </Box>
//         </AppBar>

//         {/* ══ Sidebar ═══════════════════════════════════════════════════════ */}
//         <Sidebar>
//           {nav.map(group => (
//             <SidebarSection key={group.section}>
//               <SidebarSectionLabel>{group.section}</SidebarSectionLabel>
//                 {group.items.map(item => (
//                   <NavItem
//                     key={item.id}
//                     $active={activeTab === item.id}
//                     onClick={() => {
//                       if (item.id === "candidateProfiles") {
//                         handleCandidateProfilesTab();
//                       } else {
//                         setActiveTab(item.id);
//                       }
//                     }}
//                   >
//                     {item.icon}{item.label}
//                   </NavItem>
//                 ))}
//               <SidebarDivider />
//             </SidebarSection>
//           ))}
//           <NavItem onClick={handleLogout} style={{ marginTop: "auto" }}>
//             <ExitToAppIcon />Logout
//           </NavItem>
//         </Sidebar>

//         {/* ══ Main ══════════════════════════════════════════════════════════ */}
//         <Main>

//           {/* ── Dashboard ───────────────────────────────────────────────── */}
//           {activeTab === "dashboard" && (
//             <DashPane>

//               <Box mb={2.5} display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1.5}>
//   <Box>
//     <Typography sx={{ fontFamily: "Syne", fontWeight: 800, fontSize: 24, color: "#1a1a1a", letterSpacing: "-0.5px", lineHeight: 1.2 }}>
//       {greeting}{user.first_name ? `, ${user.first_name}` : ""}
//     </Typography>
//     <Typography sx={{ fontSize: 12.5, color: "#9490A0", mt: 0.4, fontFamily: "Plus Jakarta Sans" }}>
//       Recruitment overview · {new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}
//     </Typography>
//   </Box>

//   <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1}>
//     {/* Period toggle row */}
//     <Box display="flex" alignItems="center" gap={1.2}>
//       <Box sx={{
//         display: "flex",
//         border: "0.5px solid rgba(103,80,164,0.20)",
//         borderRadius: "10px", overflow: "hidden", background: "#fff",
//       }}>
//         {PERIODS.map(p => (
//           <Box
//             key={p.value}
//             onClick={() => setPeriod(p.value)}
//             sx={{
//               px: 2, py: "7px", cursor: "pointer",
//               fontSize: 12, fontWeight: 600, fontFamily: "Plus Jakarta Sans",
//               background: period === p.value
//                 ? "linear-gradient(135deg,#6750A4,#4F378B)"
//                 : "transparent",
//               color: period === p.value ? "#fff" : "#7A6FA0",
//               transition: "all 0.16s",
//               userSelect: "none",
//               "&:hover": { background: period === p.value ? undefined : "#F0EBF8" },
//             }}
//           >
//             {p.label}
//           </Box>
//         ))}
//       </Box>

//       <Tooltip title="Refresh">
//         <IconButton onClick={fetchDashboard} size="small" sx={{
//           border: "0.5px solid rgba(0,0,0,0.08)", borderRadius: "10px",
//           bgcolor: "#fff", color: "#7A6FA0",
//           "&:hover": { bgcolor: "#EDE9F7", color: "#4F378B" },
//         }}>
//           <Refresh fontSize="small" />
//         </IconButton>
//       </Tooltip>
//     </Box>

//     {/* Custom date range — only shown when Custom is selected */}
//     {period === "custom" && (
//       <Box
//         display="flex" alignItems="center" gap={1.5}
//         sx={{
//           bgcolor: "#fff",
//           border: "0.5px solid rgba(103,80,164,0.20)",
//           borderRadius: "10px",
//           px: 2, py: 1,
//         }}
//       >
//         <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6750A4", whiteSpace: "nowrap" }}>
//           From
//         </Typography>
//         <input
//           type="date"
//           value={customStart}
//           onChange={e => setCustomStart(e.target.value)}
//           style={{
//             border: "0.5px solid rgba(103,80,164,0.25)",
//             borderRadius: 7,
//             padding: "4px 8px",
//             fontSize: 12,
//             fontFamily: "Plus Jakarta Sans, sans-serif",
//             color: "#2D1B5E",
//             outline: "none",
//             cursor: "pointer",
//             background: "#FAF8FF",
//           }}
//         />
//         <Typography sx={{ fontSize: 11, color: "#9B8DC4" }}>→</Typography>
//         <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6750A4", whiteSpace: "nowrap" }}>
//           To
//         </Typography>
//         <input
//           type="date"
//           value={customEnd}
//           onChange={e => setCustomEnd(e.target.value)}
//           style={{
//             border: "0.5px solid rgba(103,80,164,0.25)",
//             borderRadius: 7,
//             padding: "4px 8px",
//             fontSize: 12,
//             fontFamily: "Plus Jakarta Sans, sans-serif",
//             color: "#2D1B5E",
//             outline: "none",
//             cursor: "pointer",
//             background: "#FAF8FF",
//           }}
//         />
//         {customStart && customEnd && (
//           <Box sx={{
//             bgcolor: "#EDE9F7", borderRadius: "20px",
//             px: 1.2, py: 0.3,
//             fontSize: 10, fontWeight: 700, color: "#4F378B",
//             whiteSpace: "nowrap",
//           }}>
//             {Math.round((new Date(customEnd) - new Date(customStart)) / (1000 * 60 * 60 * 24))}d
//           </Box>
//         )}
//       </Box>
//     )}
//   </Box>
// </Box>

//               {error && (
//                 <Alert severity="error" sx={{ mb: 2, borderRadius: "10px", fontSize: 13 }} onClose={() => setError("")}>
//                   {error}
//                 </Alert>
//               )}

//               {loading ? (
//                 <Box display="flex" flexDirection="column" justifyContent="center"
//                   alignItems="center" minHeight="50vh" gap={2}>
//                   <CircularProgress size={32} thickness={4} sx={{ color: "#6750A4" }} />
//                   <Typography sx={{ fontSize: 13, color: "#9490A0", fontFamily: "Plus Jakarta Sans" }}>
//                     Loading dashboard…
//                   </Typography>
//                 </Box>
//               ) : (
//                 <>
//                   {/* ── 1. RBot KPIs ──────────────────────────────────── */}
//                   <SectionLabel>ResourcingBot · {currentPeriodLabel}</SectionLabel>
//                   <MetricRow>
//                     <MetricTile icon={<Groups />}        value={rbKpis.total}            label="Total candidates"  accentColor="#185FA5" accentBg="#E6F1FB" />
//                     <MetricTile icon={<NewReleases />}   value={rbKpis.ranged_total}     label="Added this period" accentColor="#534AB7" accentBg="#EEEDFE" />
//                     <MetricTile icon={<CheckCircle />}   value={rbKpis.selected}         label="Selected"          accentColor="#0F6E56" accentBg="#E1F5EE"
//                       trendPct={rbKpis.total > 0 ? Math.round((rbKpis.selected / rbKpis.total) * 100) : null} trendUp />
//                     <MetricTile icon={<TrendingUp />}    value={rbKpis.rejected}         label="Rejected"          accentColor="#A32D2D" accentBg="#FCEBEB"
//                       trendPct={rbKpis.total > 0 ? Math.round((rbKpis.rejected / rbKpis.total) * 100) : null} trendUp={false} />
//                     <MetricTile icon={<AssignmentInd />} value={rbKpis.total_recruiters} label="Active recruiters"  accentColor="#854F0B" accentBg="#FAEEDA" />
//                   </MetricRow>

//                   {/* ── 2. Bench + Employee KPIs ──────────────────────── */}
//                   <Box display="flex" gap={2.5} mb={2.5} flexWrap="wrap">
//                     <Box flex={1} minWidth={320}>
//                       <SectionLabel>Bench people</SectionLabel>
//                       <MetricRow>
//                         <MetricTile icon={<Engineering />}  value={benchTotal}      label="Total on bench"  accentColor="#185FA5" accentBg="#E6F1FB" />
//                         <MetricTile icon={<CheckCircle />}  value={benchAvailable}  label="Available"       accentColor="#0F6E56" accentBg="#E1F5EE"
//                           trendPct={benchTotal > 0 ? Math.round((benchAvailable / benchTotal) * 100) : null} trendUp />
//                         <MetricTile icon={<Work />}         value={benchOnProject}  label="On project"      accentColor="#534AB7" accentBg="#EEEDFE" />
//                         <MetricTile icon={<AccessTime />}   value={benchNotice + benchOther} label="Notice / other" accentColor="#854F0B" accentBg="#FAEEDA" />
//                       </MetricRow>
//                     </Box>
//                     <Box flex={1} minWidth={320}>
//                       <SectionLabel>Employees</SectionLabel>
//                       <MetricRow>
//                         <MetricTile icon={<SupervisorAccount />} value={empTotal}         label="Total employees"   accentColor="#534AB7" accentBg="#EEEDFE" />
//                         <MetricTile icon={<CheckCircle />}       value={empActive}        label="Active"            accentColor="#0F6E56" accentBg="#E1F5EE"
//                           trendPct={empTotal > 0 ? Math.round((empActive / empTotal) * 100) : null} trendUp />
//                         <MetricTile icon={<Domain />}            value={empActiveClients} label="Client engage."    accentColor="#185FA5" accentBg="#E6F1FB" />
//                         <MetricTile icon={<Business />}          value={empByDept.length || "—"} label="Departments" accentColor="#854F0B" accentBg="#FAEEDA" />
//                       </MetricRow>
//                     </Box>
//                   </Box>

//                   {/* ── 3. Donut + Recruiter grouped bar ─────────────── */}
//                   <Grid container spacing={2} mb={2}>
//                     <Grid item xs={12} md={4}>
//                       <ChartCard>
//                         <ChartHeader>
//                           <ChartTitle>Pipeline · stage breakdown</ChartTitle>
//                           <ChartBadge>{stageTotal} total</ChartBadge>
//                         </ChartHeader>
//                         <ChartBody>
//                           {pipelineDonutData.length === 0 ? <Empty msg="No pipeline data yet." /> : (
//                             <>
//                               <ResponsiveContainer width="100%" height={180}>
//                                 <PieChart>
//                                   <Pie data={pipelineDonutData} cx="50%" cy="50%"
//                                     innerRadius={50} outerRadius={76} paddingAngle={3} dataKey="value">
//                                     {pipelineDonutData.map((entry, i) => (
//                                       <Cell key={i} fill={entry.color} />
//                                     ))}
//                                   </Pie>
//                                   <RTooltip content={<CustomTooltip />} />
//                                 </PieChart>
//                               </ResponsiveContainer>
//                               <Box mt={1} display="flex" flexDirection="column" gap={0.7}>
//                                 {pipelineDonutData.map((d, i) => (
//                                   <Box key={i} display="flex" alignItems="center" justifyContent="space-between">
//                                     <Box display="flex" alignItems="center" gap={0.8}>
//                                       <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: d.color, flexShrink: 0 }} />
//                                       <Typography sx={{ fontSize: 11.5, color: "#444", fontFamily: "Plus Jakarta Sans" }}>{d.name}</Typography>
//                                     </Box>
//                                     <Box display="flex" alignItems="center" gap={1}>
//                                       <Typography sx={{ fontSize: 10.5, color: "#C0BDB5", fontVariantNumeric: "tabular-nums" }}>
//                                         {stageTotal > 0 ? Math.round((d.value / stageTotal) * 100) : 0}%
//                                       </Typography>
//                                       <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#1a1a1a", minWidth: 22, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
//                                         {d.value}
//                                       </Typography>
//                                     </Box>
//                                   </Box>
//                                 ))}
//                               </Box>
//                             </>
//                           )}
//                         </ChartBody>
//                       </ChartCard>
//                     </Grid>

//                     <Grid item xs={12} md={8}>
//                       <ChartCard>
//                         <ChartHeader>
//                           <ChartTitle>Recruiter performance · selected vs rejected</ChartTitle>
//                           <ChartBadge $bg="#EDE9F7" $color="#5A40A0">{currentPeriodLabel}</ChartBadge>
//                         </ChartHeader>
//                         <ChartBody>
//                           {recruiterBarData.length === 0 ? <Empty msg="No recruiter data." /> : (
//                             <ResponsiveContainer width="100%" height={250}>
//                               <BarChart data={recruiterBarData} margin={{ top: 4, right: 8, left: -16, bottom: 4 }} barSize={13} barGap={2}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fontSize: 11.5, fill: "#7A6FA0", fontFamily: "Plus Jakarta Sans" }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fontSize: 11, fill: "#B4B2A9" }} axisLine={false} tickLine={false} />
//                                 <RTooltip content={<CustomTooltip />} />
//                                 <Legend wrapperStyle={{ fontSize: 11.5, fontFamily: "Plus Jakarta Sans", paddingTop: 8 }} />
//                                 <Bar dataKey="Selected" fill="#0F6E56" radius={[4,4,0,0]} />
//                                 <Bar dataKey="Rejected" fill="#E24B4A" radius={[4,4,0,0]} />
//                                 <Bar dataKey="Active"   fill="#378ADD" radius={[4,4,0,0]} />
//                               </BarChart>
//                             </ResponsiveContainer>
//                           )}
//                         </ChartBody>
//                       </ChartCard>
//                     </Grid>
//                   </Grid>

                  

//                   {/* ── 5. Bench + Dept + Recruiter list ─────────────── */}
//                   <Grid container spacing={2} mb={2}>
//                     <Grid item xs={12} md={4}>
//                       <ChartCard>
//                         <ChartHeader>
//                           <ChartTitle>Bench · status breakdown</ChartTitle>
//                           <ChartBadge>{benchTotal ?? 0} total</ChartBadge>
//                         </ChartHeader>
//                         <ChartBody>
//                           {benchByStatus.length === 0 ? <Empty msg="No bench data yet." /> : (
//                             [...benchByStatus].sort((a, b) => b.count - a.count).map(item => {
//                               const cfg = BENCH_COLORS[item._id] ?? { c: "#5F5E5A", bg: "#F1EFE8" };
//                               return (
//                                 <HBar key={item._id} label={item._id || "Unknown"}
//                                   count={item.count} maxCount={benchMaxCount}
//                                   color={cfg.c} bg={cfg.bg}
//                                   pct={benchTotal > 0 ? Math.round((item.count / benchTotal) * 100) : 0} />
//                               );
//                             })
//                           )}
//                         </ChartBody>
//                       </ChartCard>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <ChartCard>
//                         <ChartHeader>
//                           <ChartTitle>Employees · by department</ChartTitle>
//                           <ChartBadge>{empTotal ?? 0} total</ChartBadge>
//                         </ChartHeader>
//                         <ChartBody>
//                           {empByDept.length === 0 ? <Empty msg="No employee data yet." /> : (
//                             [...empByDept].sort((a, b) => b.count - a.count).map((item, i) => (
//                               <HBar key={item._id ?? i} label={item._id || "Unassigned"}
//                                 count={item.count} maxCount={empMaxDept}
//                                 color={DEPT_COLORS[i % DEPT_COLORS.length]}
//                                 bg={DEPT_BGS[i % DEPT_BGS.length]}
//                                 pct={empTotal > 0 ? Math.round((item.count / empTotal) * 100) : 0} />
//                             ))
//                           )}
//                         </ChartBody>
//                       </ChartCard>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <ChartCard>
//                         <ChartHeader>
//                           <ChartTitle>Recruiter performance list</ChartTitle>
//                           <ChartBadge $bg="#EDE9F7" $color="#5A40A0">RBot</ChartBadge>
//                         </ChartHeader>
//                         <ChartBody>
//                           {rbRecruiters.length === 0 ? <Empty msg="No recruiter data." /> : (
//                             <Box display="flex" flexDirection="column" gap={1.5}>
//                               {rbRecruiters.map((r, i) => {
//                                 const selPct = r.total > 0 ? Math.round((r.selected / r.total) * 100) : 0;
//                                 return (
//                                   <Box key={r.recruiter_id}>
//                                     <Box display="flex" alignItems="center" gap={1} mb={0.4}>
//                                       <Avatar sx={{
//                                         width: 24, height: 24, fontSize: 10, fontWeight: 700,
//                                         bgcolor: STAGE_BGS[i % STAGE_BGS.length],
//                                         color: STAGE_COLORS[i % STAGE_COLORS.length], flexShrink: 0,
//                                       }}>
//                                         {(r.recruiter_name || "?")[0].toUpperCase()}
//                                       </Avatar>
//                                       <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#1a1a1a", flex: 1, fontFamily: "Plus Jakarta Sans", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} noWrap>
//                                         {r.recruiter_name}
//                                       </Typography>
//                                       <Box display="flex" gap={0.6} alignItems="center" flexShrink={0}>
//                                         <Typography sx={{ fontSize: 11.5, color: "#0F6E56", fontWeight: 700 }}>{r.selected}</Typography>
//                                         <Typography sx={{ fontSize: 10.5, color: "#B4B2A9" }}>/{r.total}</Typography>
//                                         <Chip label={`${selPct}%`} size="small" sx={{
//                                           fontSize: 9.5, fontWeight: 700, height: 16, border: "none",
//                                           bgcolor: selPct >= 50 ? "#E1F5EE" : selPct >= 25 ? "#FAEEDA" : "#FCEBEB",
//                                           color:   selPct >= 50 ? "#0F6E56" : selPct >= 25 ? "#633806" : "#791F1F",
//                                         }} />
//                                       </Box>
//                                     </Box>
//                                     <Box sx={{ height: 4, borderRadius: 99, bgcolor: STAGE_BGS[i % STAGE_BGS.length], overflow: "hidden" }}>
//                                       <Box sx={{
//                                         width: `${maxRbRec > 0 ? (r.selected / maxRbRec) * 100 : 0}%`,
//                                         height: "100%", bgcolor: STAGE_COLORS[i % STAGE_COLORS.length],
//                                         borderRadius: 99, transition: "width 0.4s ease",
//                                       }} />
//                                     </Box>
//                                   </Box>
//                                 );
//                               })}
//                             </Box>
//                           )}
//                         </ChartBody>
//                       </ChartCard>
//                     </Grid>
//                   </Grid>

//                   {/* ── 6. Top active JDs ─────────────────────────────── */}
//                   <ChartCard>
//                     <ChartHeader>
//                       <ChartTitle>Top active JDs · RBot</ChartTitle>
//                       <ChartBadge>{rbJdOverall.length} shown</ChartBadge>
//                     </ChartHeader>
//                     <ChartBody>
//                       {rbJdOverall.length === 0 ? <Empty msg="No JD data." /> : (
//                         <Grid container spacing={1.2}>
//                           {rbJdOverall.map((jd, i) => {
//                             const selPct = jd.total > 0 ? Math.round((jd.selected / jd.total) * 100) : 0;
//                             return (
//                               <Grid item xs={12} sm={6} md={4} key={jd.jdID}>
//                                 <Box sx={{
//                                   display: "flex", alignItems: "center", gap: 1.2,
//                                   p: "10px 13px", borderRadius: "10px",
//                                   border: "0.5px solid rgba(0,0,0,0.07)", bgcolor: "#FAFAF9",
//                                   "&:hover": { bgcolor: "#F3EEF9", borderColor: "rgba(103,80,164,0.14)" },
//                                   transition: "all 0.14s",
//                                 }}>
//                                   <Box sx={{
//                                     width: 28, height: 28, borderRadius: "7px",
//                                     bgcolor: STAGE_BGS[i % STAGE_BGS.length],
//                                     display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
//                                   }}>
//                                     <Work sx={{ fontSize: 13, color: STAGE_COLORS[i % STAGE_COLORS.length] }} />
//                                   </Box>
//                                   <Box flex={1} minWidth={0}>
//                                     <Box display="flex" alignItems="baseline" gap={0.8}>
//                                       <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", fontFamily: "Plus Jakarta Sans", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} noWrap>
//                                         {jd.jobRole || "—"}
//                                       </Typography>
//                                       <Typography sx={{ fontSize: 10, color: "#C0BDB5", fontFamily: "monospace", flexShrink: 0 }}>
//                                         {jd.jdID}
//                                       </Typography>
//                                     </Box>
//                                     <Typography sx={{ fontSize: 10.5, color: "#888780", fontFamily: "Plus Jakarta Sans" }}>{jd.companyName}</Typography>
//                                   </Box>
//                                   <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.3} flexShrink={0}>
//                                     <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "#0F6E56", fontVariantNumeric: "tabular-nums" }}>
//                                       {jd.selected} sel
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 10, color: "#B4B2A9" }}>
//                                       {jd.total} · {selPct}%
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </Grid>
//                             );
//                           })}
//                         </Grid>
//                       )}
//                     </ChartBody>
//                   </ChartCard>
//                 </>
//               )}
//             </DashPane>
//           )}

//           {/* ── Sub-pages ──────────────────────────────────────────────── */}
//           {activeTab === "benchPeople"        && <SubPagePane><BenchPeople /></SubPagePane>}
//           {activeTab === "allclientanalytics" && <SubPagePane><AllClientsAnalytics /></SubPagePane>}
//           {/* {activeTab === "clients"            && <SubPagePane><ClientManagement /></SubPagePane>} */}
//           {activeTab === "clients" && (
//               <SubPagePane>
//                 <ClientManagement
//                   onViewJobs={handleViewClientJobs}
//                   onViewCandidates={handleViewClientJobs}
//                 />
//               </SubPagePane>
//             )}
//           {activeTab === "recruiterreports"   && <SubPagePane><RbotManagerDashboard period={period} /></SubPagePane>}
//           {activeTab === "employees"          && <SubPagePane><Employees /></SubPagePane>}
//           {/* {activeTab === "candidateProfiles" && <SubPagePane><CandidateBrowserPage /></SubPagePane>} */}
//           {activeTab === "candidateProfiles" && (
//             <SubPagePane>
//               <CandidateBrowserPage initialCompany={candidateBrowserCompany} />
//             </SubPagePane>
//           )}
//           {activeTab === 'summary' && (
//              <SubPagePane>
//               <ClientSummaryReport />
//               </SubPagePane>
//             )}

//           {activeTab === "profile" && (
//             <SubPagePane>
//               <Typography sx={{ fontFamily: "Syne", fontWeight: 800, fontSize: 26, color: "#1a1a1a", letterSpacing: "-0.5px", mb: 0.5 }}>
//                 My Profile
//               </Typography>
//               <Typography sx={{ fontSize: 13, color: "#9490A0", mb: 3, fontFamily: "Plus Jakarta Sans" }}>
//                 View and update your account details
//               </Typography>
//               <ProfileForm
//                 userData={{
//                   name: fullName,
//                   email: user?.email || "",
//                   phone: user?.phone || "",
//                   userType: user?.role || user?.userType || "Manager",
//                 }}
//               />
//             </SubPagePane>
//           )}

//         </Main>
//       </Shell>
//     </>
//   );
// }









import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import {
  Box, Grid, Typography, Chip, CircularProgress,
  Alert, Avatar, IconButton, Tooltip, CssBaseline, Button,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {
  Work, CheckCircle, TrendingUp, NewReleases,
  FiberManualRecord, Business, AssignmentInd, Groups,
  Engineering, AccessTime, Domain, SupervisorAccount,
  ArrowUpward, ArrowDownward, Refresh,
  Dashboard as DashboardIcon, PersonOutline, BadgeOutlined, Assessment,
  AccountCircle as AccountCircleIcon, ExitToApp as ExitToAppIcon,
  Notifications as NotificationsIcon, Business as BusinessIcon, Assessment as AssessmentIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import axios from "axios";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RTooltip,
  Legend, ResponsiveContainer,
} from "recharts";
import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import BenchPeople       from "../HRPages/BenchPeople/Benchpeople.js";
import Employees         from "../HRPages/EmployeePages/EmployeesPage.js";
import ProfileForm       from "../shared/Profileform.js";
import ClientManagement  from "../HiringManager/Clientmanagement.js";
import AllClientsAnalytics from "../ManagerPages/ClientManagement/ClientAnalytics.js";
import RbotManagerDashboard from "./RbotManagerDashboard.js";
import CandidateBrowserPage from "./CandidateManagement/Candidatebrowserpage.js";
import ClientSummaryReport from "../Reports/ClientSummaryReport.js";
import recruiterTheme, {
  FONT_BODY, FONT_DISPLAY, COLORS, TYPE, RADIUS, SHADOW, PAGE_PADDING,
} from "../../styles/recruiterTheme";


// ─── Globals ──────────────────────────────────────────────────────────────────
const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box; margin: 0; padding: 0; }
  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: rgba(103,80,164,0.2); border-radius: 99px; }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// ─── Layout shell ─────────────────────────────────────────────────────────────
const Shell = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${COLORS.background};
  font-family: ${FONT_BODY};
  padding-top: 68px;
`;

const AppBar = styled.header`
  position: fixed;
  top: 0; left: 0; right: 0;
  height: 68px;
  background: rgba(255,255,255,0.98);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(103,80,164,0.10);
  box-shadow: 0 2px 16px rgba(55,30,110,0.07);
  z-index: 1300;
  display: flex;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding-right: 24px;
  border-right: 1.5px solid rgba(103,80,164,0.10);
`;

const BrandLogo = styled.div`
  width: 44px; height: 44px;
  border-radius: 13px;
  background: linear-gradient(135deg, #EDE7F6, #D0BCFF);
  border: 1.5px solid rgba(103,80,164,0.16);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 3px 12px rgba(79,55,139,0.14);
  flex-shrink: 0;
`;

const BrandName = styled.div`
  font-family: ${FONT_DISPLAY};
  font-weight: 800;
  font-size: ${TYPE.section}px;
  background: linear-gradient(135deg, #2D1B5E 0%, #6750A4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
  line-height: 1;
  white-space: nowrap;
`;

const BrandSub = styled.div`
  font-family: ${FONT_BODY};
  font-size: ${TYPE.overline}px;
  font-weight: 700;
  color: #9B8DC4;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 3px;
`;

const UserPill = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #F6F2FF, #EDE7F6);
  border: 1px solid rgba(103,80,164,0.13);
  border-radius: 36px;
  padding: 5px 14px 5px 5px;
  white-space: nowrap;
`;

const UserAvatar = styled.div`
  width: 36px; height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7C5CBF, #4F378B);
  color: #fff;
  font-family: ${FONT_BODY};
  font-weight: 700;
  font-size: ${TYPE.small}px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 8px rgba(79,55,139,0.3);
  flex-shrink: 0;
`;

const BellBtn = styled.button`
  width: 40px; height: 40px;
  background: linear-gradient(135deg, #F3EEF9, #E8DEF8);
  border: none; border-radius: ${RADIUS.sm}px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: all 0.18s; flex-shrink: 0;
  &:hover { background: linear-gradient(135deg, #E8DEF8, #D0BCFF); transform: scale(1.06); }
  svg { color: #5A40A0; font-size: 21px; }
`;

// ─── Sidebar ──────────────────────────────────────────────────────────────────
const Sidebar = styled.nav`
  width: 240px;
  min-width: 240px;
  flex-shrink: 0;
  background: linear-gradient(168deg, #1E1245 0%, #3D2A7A 52%, #6750A4 100%);
  height: calc(100vh - 68px);
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  padding: 16px 10px 20px;
  overflow-y: auto;
  box-shadow: 4px 0 28px rgba(55,30,110,0.22);
  z-index: 10;
`;

const SidebarSection = styled.div`
  margin-top: 16px;
`;

const SidebarSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.35);
  padding: 0 10px;
  margin-bottom: 5px;
`;

const NavItem = styled.button`
  width: 100%;
  background: ${p => p.$active ? "rgba(255,255,255,0.16)" : "transparent"};
  border: none;
  border-radius: ${RADIUS.sm}px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${p => p.$active ? "#fff" : "rgba(255,255,255,0.70)"};
  font-family: ${FONT_BODY};
  font-size: 13px;
  font-weight: ${p => p.$active ? 700 : 500};
  cursor: pointer;
  transition: all 0.16s;
  margin-bottom: 2px;
  text-align: left;
  outline: none;
  position: relative;
  &:hover { background: rgba(255,255,255,0.11); color: #fff; }
  svg { font-size: 18px; flex-shrink: 0; }
  &::before {
    content: '';
    position: absolute;
    left: 0; top: 20%; bottom: 20%;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: #D0BCFF;
    opacity: ${p => p.$active ? 1 : 0};
    transition: opacity 0.16s;
  }
`;

const SidebarDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
  margin: 12px 0;
`;

// ─── Main content area ────────────────────────────────────────────────────────
const Main = styled.main`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  height: calc(100vh - 68px);
  background: ${COLORS.background};
`;

// "Cards on canvas": every tab sits in this transparent padded container;
// embedded tab components add no outer padding of their own.
const DashPane = styled.div`
  padding: ${PAGE_PADDING}px;
  animation: ${fadeUp} 0.34s ease both;
`;

const SubPagePane = styled.div`
  padding: ${PAGE_PADDING}px;
  min-width: 0;
  animation: ${fadeUp} 0.34s ease both;
`;

// ─── Section label ────────────────────────────────────────────────────────────
const SectionLabel = ({ children }) => (
  <Typography sx={{
    fontSize: TYPE.overline, fontWeight: 700, color: COLORS.muted,
    textTransform: "uppercase", letterSpacing: "0.08em",
    mb: 1, mt: 0.5, fontFamily: FONT_BODY,
  }}>
    {children}
  </Typography>
);

// ─── Metric tile — fixed layout with no overflow ──────────────────────────────
const MetricTile = ({ icon, value, label, accentColor, accentBg, trendPct, trendUp }) => (
  <Box sx={{
    flex: "1 1 0",
    minWidth: 0,
    background: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
    borderRadius: `${RADIUS.md}px`,
    boxShadow: SHADOW.card,
    p: 2,
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    transition: "box-shadow 0.16s, transform 0.16s",
    "&:hover": { boxShadow: "0 4px 20px rgba(79,55,139,0.10)", transform: "translateY(-1px)" },
  }}>
    <Box sx={{
      width: 36, height: 36, borderRadius: `${RADIUS.sm}px`,
      background: accentBg, flexShrink: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      {React.cloneElement(icon, { sx: { fontSize: 18, color: accentColor } })}
    </Box>

    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography sx={{
        fontFamily: FONT_BODY, fontWeight: 800, fontSize: TYPE.section,
        color: "#1a1a1a", lineHeight: 1, fontVariantNumeric: "tabular-nums",
      }}>
        {value ?? "—"}
      </Typography>
      <Typography sx={{
        fontSize: TYPE.caption, fontWeight: 500, color: "#7A6FA0",
        mt: 0.5, lineHeight: 1.3,
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
      }}>
        {label}
      </Typography>
    </Box>

    {trendPct != null && (
      <Box sx={{
        display: "flex", alignItems: "center", gap: "2px",
        background: trendUp ? "#E1F5EE" : "#FCEBEB",
        borderRadius: "20px", px: "7px", py: "3px",
        flexShrink: 0,
      }}>
        {trendUp
          ? <ArrowUpward sx={{ fontSize: 11, color: "#0F6E56" }} />
          : <ArrowDownward sx={{ fontSize: 11, color: "#A32D2D" }} />}
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: trendUp ? "#0F6E56" : "#A32D2D", lineHeight: 1 }}>
          {trendPct}%
        </Typography>
      </Box>
    )}
  </Box>
);

// ─── Metric row — flex container that never wraps (scrolls on tiny screens) ──
const MetricRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  overflow-x: auto;
  padding-bottom: 2px;
`;

// ─── Chart card ───────────────────────────────────────────────────────────────
const ChartCard = styled.div`
  background: ${COLORS.surface};
  border: 1px solid ${COLORS.border};
  border-radius: ${RADIUS.lg}px;
  box-shadow: ${SHADOW.card};
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ChartHeader = styled.div`
  padding: 16px 24px 12px;
  border-bottom: 1px solid ${COLORS.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
`;

const ChartTitle = styled.div`
  font-family: ${FONT_BODY};
  font-size: ${TYPE.body}px;
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ChartBadge = styled.span`
  font-family: ${FONT_BODY};
  font-size: 11px;
  font-weight: 600;
  background: ${p => p.$bg || "#F1EFE8"};
  color: ${p => p.$color || "#5F5E5A"};
  border-radius: ${RADIUS.pill}px;
  padding: 2px 8px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex-shrink: 0;
`;

const ChartBody = styled.div`
  padding: 16px 24px;
  flex: 1;
`;

// ─── Horizontal bar row ───────────────────────────────────────────────────────
const HBar = ({ label, count, maxCount, color, bg, pct }) => (
  <Box mb={1.5}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.4}>
      <Box display="flex" alignItems="center" gap={0.8} sx={{ minWidth: 0, flex: 1, mr: 1 }}>
        <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: color, flexShrink: 0 }} />
        <Typography sx={{
          fontSize: 12, color: "#2C2C2A", fontFamily: FONT_BODY,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>
          {label}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1} flexShrink={0}>
        {pct !== undefined && (
          <Typography sx={{ fontSize: 11, color: "#C0BDB5", fontVariantNumeric: "tabular-nums" }}>{pct}%</Typography>
        )}
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", minWidth: 22, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
          {count}
        </Typography>
      </Box>
    </Box>
    <Box sx={{ height: 5, borderRadius: 99, bgcolor: bg, overflow: "hidden" }}>
      <Box sx={{ width: `${maxCount > 0 ? (count / maxCount) * 100 : 0}%`, height: "100%", bgcolor: color, borderRadius: 99, transition: "width 0.4s ease" }} />
    </Box>
  </Box>
);

const Empty = ({ msg }) => (
  <Box py={4} textAlign="center">
    <Typography sx={{ fontSize: TYPE.small, color: COLORS.faint, fontFamily: FONT_BODY }}>{msg}</Typography>
  </Box>
);

// ─── FUNNEL STAGE MODEL (candidate flow) ──────────────────────────────────────
// "Reached-at-least" counting: each stage counts every candidate who advanced to
// at least that step, so the funnel decreases monotonically. AUDIT this map
// against your real process; change a status's number to move it between stages.
// Stages: 1 Applied · 2 Recruiter · 3 HM · 4 Test · 5 Interview · 6 Selected
const OV_FURTHEST_STAGE = {
  NewCandidate: 1, Recruiter_Rejected: 1, Rejected: 1,
  Recruiter_Accepted: 2, Recruiter_Hold: 2, HiringManager_Rejected: 2,
  HiringManager_Accepted: 3, HiringManager_Hold: 3,
  ScreeningTest_Sent: 4, ScreeningTest_Resent: 4, Candidate_Declined: 4,
  Candidate_OnHold: 4, Candidate_Quit: 4, ScreeningTest_Passed: 4,
  ReScreeningTest_Passed: 4, OnHold_ReScreening: 4, OnHold_Screening: 4,
  TestPassed_Rejected: 4, ReTestPassed_Rejected: 4, ScreeningTest_Failed: 4,
  ReScreeningTest_Failed: 4, OnHold_TestPassed: 4,
  Interview_Scheduled: 5, Round1_Rejected: 5, Round2_Suggested: 5,
  Round2_Scheduled: 5, Interviewer_Selected: 5, Interviewer_Rejected: 5,
  Selected: 6,
};

const OV_STAGES = [
  { key: "applied",   label: "Applied",          c: "#534AB7" },
  { key: "recruiter", label: "Recruiter Screen", c: "#185FA5" },
  { key: "hm",        label: "HM Review",        c: "#0F6E56" },
  { key: "test",      label: "Screening Test",   c: "#854F0B" },
  { key: "interview", label: "Interview",        c: "#6750A4" },
  { key: "selected",  label: "Selected",         c: "#0F6E56" },
];

function buildOverviewFunnel(statusCounts = {}) {
  const reached = [0, 0, 0, 0, 0, 0];
  Object.entries(statusCounts).forEach(([status, count]) => {
    const furthest = OV_FURTHEST_STAGE[status] ?? 1;
    for (let s = 0; s < furthest; s++) reached[s] += count;
  });
  const applied = reached[0] || 0;
  return OV_STAGES.map((st, i) => ({
    ...st,
    value: reached[i],
    pctOfTop:  applied > 0 ? (reached[i] / applied) * 100 : 0,
    pctOfPrev: i === 0 ? 100 : (reached[i - 1] > 0 ? (reached[i] / reached[i - 1]) * 100 : 0),
  }));
}

// ─── Pipeline funnel (centered narrowing bars) ────────────────────────────────
const PipelineFunnel = ({ statusCounts }) => {
  const rows = buildOverviewFunnel(statusCounts);
  const top = rows[0].value || 1;
  const selectedPct = rows[rows.length - 1].pctOfTop;

  if (top <= 0) return <Empty msg="No candidates in pipeline yet." />;

  return (
    <Box>
      <Box display="flex" alignItems="baseline" gap={1} mb={1.5}>
        <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 800, fontSize: TYPE.page, color: "#1a1a1a", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
          {selectedPct.toFixed(1)}%
        </Typography>
        <Typography sx={{ fontSize: 12, color: "#7A6FA0", fontFamily: FONT_BODY }}>
          applied → selected
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" gap={1.4}>
        {rows.map((r, i) => {
          const widthPct = (r.value / top) * 100;
          return (
            <Box key={r.key}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.4}>
                <Box display="flex" alignItems="center" gap={0.8} sx={{ minWidth: 0, flex: 1, mr: 1 }}>
                  <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: r.c, flexShrink: 0 }} />
                  <Typography sx={{
                    fontSize: 12, color: "#2C2C2A", fontFamily: FONT_BODY,
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}>
                    {r.label}
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1} flexShrink={0}>
                  {i > 0 && (
                    <Typography sx={{
                      fontSize: 11, fontWeight: 700, fontVariantNumeric: "tabular-nums",
                      color: r.pctOfPrev >= 60 ? "#0F6E56" : r.pctOfPrev >= 30 ? "#854F0B" : "#A32D2D",
                    }}>
                      {r.pctOfPrev.toFixed(0)}%
                    </Typography>
                  )}
                  <Typography sx={{
                    fontSize: 13, fontWeight: 700, color: "#1a1a1a",
                    minWidth: 26, textAlign: "right", fontVariantNumeric: "tabular-nums",
                  }}>
                    {r.value}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box sx={{
                  width: `${Math.max(widthPct, 4)}%`, height: 22, borderRadius: "6px",
                  background: `linear-gradient(90deg, ${r.c}, ${r.c}cc)`,
                  transition: "width 0.45s ease",
                }} />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

// ─── Priority meta ────────────────────────────────────────────────────────────
const PRIORITY_META = {
  Critical: { bg: "#FCEBEB", color: "#791F1F", dot: "#E24B4A", border: "#F09595" },
  High:     { bg: "#FAEEDA", color: "#633806", dot: "#EF9F27", border: "#FAC775" },
  Medium:   { bg: "#E6F1FB", color: "#0C447C", dot: "#378ADD", border: "#B5D4F4" },
};

const STAGE_COLORS = ["#5A40A0","#0F6E56","#185FA5","#854F0B","#A32D2D","#993556"];
const STAGE_BGS    = ["#EDE9F7","#E1F5EE","#E6F1FB","#FAEEDA","#FCEBEB","#FBEAF0"];
const DEPT_COLORS  = ["#185FA5","#0F6E56","#854F0B","#534AB7","#993C1D","#993556","#3B6D11","#5F5E5A"];
const DEPT_BGS     = ["#E6F1FB","#E1F5EE","#FAEEDA","#EEEDFE","#FAECE7","#FBEAF0","#EAF3DE","#F1EFE8"];

const BENCH_COLORS = {
  "Available":      { c: "#0F6E56", bg: "#E1F5EE" },
  "On Project":     { c: "#185FA5", bg: "#E6F1FB" },
  "Notice Period":  { c: "#854F0B", bg: "#FAEEDA" },
  "Pending Review": { c: "#534AB7", bg: "#EEEDFE" },
  "Inactive":       { c: "#5F5E5A", bg: "#F1EFE8" },
};

// ─── Recharts tooltip ─────────────────────────────────────────────────────────
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: "#fff", border: "0.5px solid rgba(0,0,0,0.10)",
      borderRadius: RADIUS.sm, padding: "8px 16px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      fontFamily: FONT_BODY, fontSize: 12,
    }}>
      {label && <div style={{ fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{label}</div>}
      {payload.map((p, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, color: "#444", marginTop: 2 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: p.color, display: "inline-block", flexShrink: 0 }} />
          <span>{p.name}:</span>
          <span style={{ fontWeight: 700, color: "#1a1a1a" }}>{p.value}</span>
        </div>
      ))}
    </div>
  );
};

// ─── API helpers ──────────────────────────────────────────────────────────────
const API_URL  = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token") || "";

const authFetch = async (url) => {
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
  });
  if (res.status === 401) { localStorage.clear(); window.location.href = "/login"; }
  return res;
};

const statusCount = (arr = [], key) => arr.find((s) => s._id === key)?.count ?? 0;

// Local calendar date as YYYY-MM-DD (toISOString() would give the UTC date).
const pad2 = (n) => String(n).padStart(2, "0");
const localDateStr = (d = new Date()) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

// ─── Session / user helpers (same contract as the recruiter dashboard) ───────
const DEFAULT_TAB    = "dashboard";
const TAB_KEY        = "activeTab";
const RETURN_TAB_KEY = "returnTab";
const PERSISTABLE_TABS = new Set([
  "dashboard", "allclientanalytics", "recruiterreports", "clients",
  "benchPeople", "employees", "candidateProfiles", "summary", "profile",
]);

const readSession = (key) => {
  try { return sessionStorage.getItem(key); } catch { return null; }
};
const writeSession = (key, value) => {
  try { sessionStorage.setItem(key, value); } catch { /* storage unavailable */ }
};
const removeSession = (key) => {
  try { sessionStorage.removeItem(key); } catch { /* storage unavailable */ }
};

const readJsonStorage = (key) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key));
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

const safeJson = async (res) => {
  try { return await res.json(); } catch { return {}; }
};

// ─── Period config ────────────────────────────────────────────────────────────
const PERIODS = [
  { label: "7d",  value: "week"    },
  { label: "30d", value: "month"   },
  { label: "90d", value: "quarter" },
  { label: "Custom", value: "custom" },
];

const dateInputStyle = {
  border: "1px solid rgba(103,80,164,0.25)",
  borderRadius: RADIUS.sm,
  padding: "4px 8px",
  height: 32,
  fontSize: TYPE.caption,
  fontFamily: FONT_BODY,
  color: "#2D1B5E",
  outline: "none",
  cursor: "pointer",
  background: "#FAF8FF",
};

// ═════════════════════════════════════════════════════════════════════════════
export default function ManagerDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  // User comes from navigation state (fresh login) or, after a refresh, from the
  // profile Login.js stores in localStorage (`rbotUser`); the legacy `user` key
  // is only a last resort.
  const user = useMemo(() => {
    if (location.state?.email) return location.state;
    const stored = readJsonStorage("rbotUser");
    if (stored?.email) return stored;
    const legacy = readJsonStorage("user");
    return legacy?.email ? legacy : null;
  }, [location.state]);

  const legacyName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
  const fullName   = (user?.name || legacyName || "Manager").trim();
  const firstName  = user?.first_name || (user?.name ? user.name.trim().split(/\s+/)[0] : "");
  const initials   = fullName.split(/\s+/).filter(Boolean).slice(0, 2)
    .map((w) => w[0]?.toUpperCase()).join("") || "MG";
  const logoutApiUrl = process.env.REACT_APP_LOGOUT_API;

  useEffect(() => {
    if (!user) navigate("/login", { replace: true });
  }, [user, navigate]);

  const [activeTab, setActiveTab] = useState(() => {
    const saved = readSession(TAB_KEY);
    return saved && PERSISTABLE_TABS.has(saved) ? saved : DEFAULT_TAB;
  });
  const [tabRefreshKey, setTabRefreshKey] = useState(0);
  const [period,    setPeriod]    = useState("month");
  const [customStart, setCustomStart] = useState(localDateStr());
  const [customEnd,   setCustomEnd]   = useState(localDateStr());

  const [portal,     setPortal]     = useState(null);
  const [rbot,       setRbot]       = useState(null);
  const [benchStats, setBenchStats] = useState(null);
  const [benchTotal, setBenchTotal] = useState(null);
  const [empStats,   setEmpStats]   = useState(null);
  const [empTotal,   setEmpTotal]   = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState("");
  const [candidateBrowserCompany, setCandidateBrowserCompany] = useState(null);
  const [loggingOut, setLoggingOut] = useState(false);
  const fetchSeq = useRef(0);

  const customRangeInvalid = period === "custom" && (!customStart || !customEnd || customStart > customEnd);

  const fetchDashboard = useCallback(async () => {
    if (period === "custom" && (!customStart || !customEnd || customStart > customEnd)) return;
    // Only the latest request may write state (fast period clicks / date edits).
    const seq = ++fetchSeq.current;
    setLoading(true);
    setError("");
    try {
      const periodParam = period === "custom"
        ? `custom&start=${customStart}&end=${customEnd}`
        : period;

      const responses = await Promise.all([
        authFetch(`${API_URL}/dashboard/`),
        authFetch(`${API_URL}/rbot-dashboard/manager?period=${periodParam}`),
        authFetch(`${API_URL}/bench/stats`),
        authFetch(`${API_URL}/bench/?page=1&per_page=1`),
        authFetch(`${API_URL}/employees/stats`),
        authFetch(`${API_URL}/employees/?page=1&per_page=1`),
      ]);
      const [pJ, rJ, bsJ, blJ, esJ, elJ] = await Promise.all(responses.map(safeJson));
      if (seq !== fetchSeq.current) return;
      // A failed section shows "—" instead of keeping figures from another period.
      setPortal(pJ?.success ? (pJ.dashboard ?? {}) : null);
      setRbot(rJ?.success ? rJ : null);
      setBenchStats(bsJ?.success ? (bsJ.data ?? {}) : null);
      setBenchTotal(blJ?.success ? (blJ.total ?? 0) : null);
      setEmpStats(esJ?.success ? (esJ.data ?? {}) : null);
      setEmpTotal(elJ?.success ? (elJ.total ?? 0) : null);
      const failed = [pJ, rJ, bsJ, blJ, esJ, elJ].filter((j) => !j?.success).length;
      if (failed === 6) setError("Unable to load dashboard data.");
      else if (failed > 0) setError("Some dashboard sections could not be loaded.");
    } catch {
      if (seq === fetchSeq.current) setError("Unable to load dashboard data.");
    } finally {
      if (seq === fetchSeq.current) setLoading(false);
    }
  }, [period, customStart, customEnd]);

  // Dashboard data loads on first mount, on every switch to the tab, when the
  // sidebar item is clicked again (tabRefreshKey) and when the period changes.
  useEffect(() => {
    if (activeTab === "dashboard" && user) fetchDashboard();
  }, [fetchDashboard, activeTab, tabRefreshKey, user]);

  // Persist the current tab so F5 restores it.
  useEffect(() => {
    if (PERSISTABLE_TABS.has(activeTab)) writeSession(TAB_KEY, activeTab);
  }, [activeTab]);

  /** Single in-app tab switch: resets sub-view state and remounts/refetches the tab. */
  const switchTab = useCallback((tab, { company = null } = {}) => {
    removeSession(RETURN_TAB_KEY);
    setCandidateBrowserCompany(company);
    setActiveTab(tab);
    setTabRefreshKey((k) => k + 1);
  }, []);

  const handleLogout = useCallback(async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    const em = user?.email || localStorage.getItem("email");
    const tokens = readJsonStorage("userTokens") || {};
    const storedToken = localStorage.getItem("token");
    const token = (em && tokens[em]) || (storedToken && storedToken !== "null" ? storedToken : null);
    try {
      if (token && logoutApiUrl) {
        await axios.post(logoutApiUrl, { token, email: em }, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch (err) {
      console.error("[ManagerDashboard] Logout failed:", err.message);
    } finally {
      if (em) delete tokens[em];
      localStorage.setItem("userTokens", JSON.stringify(tokens));
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("rbotUser");
      localStorage.removeItem("user");
      removeSession(TAB_KEY);
      removeSession(RETURN_TAB_KEY);
      navigate("/login", { replace: true });
    }
  }, [loggingOut, user, logoutApiUrl, navigate]);

  // Clients → "View jobs / candidates" opens the candidate browser filtered to that client.
  const handleViewClientJobs = useCallback((client) => {
    switchTab("candidateProfiles", { company: client?.company_name || null });
  }, [switchTab]);

  // ── Derived ───────────────────────────────────────────────────────────────
  const stageCounts  = portal?.stage_counts       ?? [];
  const highJobs     = portal?.high_priority_jobs ?? [];
  const rbKpis       = rbot?.kpis                 ?? {};
  const rbStatusCounts = rbot?.team_status_counts ?? {};   // ← drives the funnel
  const rbRecruiters = (rbot?.recruiter_breakdown ?? [])
    .filter(r => r.recruiter_id !== "Other" && r.recruiter_name !== "Other").slice(0, 6);
  const rbJdOverall  = (rbot?.jd_overall ?? []).slice(0, 6);

  const benchByStatus  = benchStats?.by_status ?? [];
  const benchAvailable = statusCount(benchByStatus, "Available");
  const benchOnProject = statusCount(benchByStatus, "On Project");
  const benchNotice    = statusCount(benchByStatus, "Notice Period");
  const benchOther     = Math.max(0, (benchTotal ?? 0) - benchAvailable - benchOnProject - benchNotice);
  const benchMaxCount  = Math.max(1, ...benchByStatus.map(s => s.count));

  const empByStatus      = empStats?.by_status     ?? [];
  const empByDept        = empStats?.by_department ?? [];
  const empActive        = statusCount(empByStatus, "Active");
  const empActiveClients = empStats?.active_clients ?? 0;
  const empMaxDept       = Math.max(1, ...empByDept.map(d => d.count));

  const maxRbRec   = Math.max(1, ...rbRecruiters.map(r => r.selected));

  const hour     = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  const currentPeriodLabel = period === "custom" && customStart && customEnd
    ? `${customStart} → ${customEnd}`
    : PERIODS.find(p => p.value === period)?.label ?? "30d";

  const recruiterBarData = rbRecruiters.map(r => ({
    name:     (r.recruiter_name || "?").split(" ")[0],
    Selected: r.selected ?? 0,
    Rejected: r.rejected ?? 0,
    Active:   Math.max(0, (r.total ?? 0) - (r.selected ?? 0) - (r.rejected ?? 0)),
  }));

  // ─── Sidebar nav ──────────────────────────────────────────────────────────
  const nav = [
    {
      section: "Overview",
      items: [
        { id: "dashboard",          icon: <DashboardIcon />,     label: "Dashboard"        },
        { id: "allclientanalytics", icon: <BusinessIcon />,      label: "Client Analytics" },
        { id: "recruiterreports",   icon: <Assessment />,        label: "Team Analytics"   },
      ],
    },
    {
      section: "Manage",
      items: [
        { id: "clients",    icon: <BusinessIcon />,  label: "Clients"      },
        { id: "benchPeople",icon: <PersonOutline />, label: "Bench People" },
        { id: "employees",  icon: <BadgeOutlined />, label: "Employees"    },
        { id: "candidateProfiles",  icon: <RecentActorsOutlinedIcon />, label: "Candidate Profiles"    },
        { id: "summary",  icon: <AssessmentIcon />, label: "Summary Report"    },
      ],
    },
    {
      section: "Account",
      items: [
        { id: "profile", icon: <AccountCircleIcon />, label: "Profile" },
      ],
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────
  if (!user) return null;

  const hasDashboardData = Boolean(portal || rbot || benchStats || empStats);

  return (
    <ThemeProvider theme={recruiterTheme}>
      <GlobalStyle />
      <CssBaseline />
      <Shell>

        {/* ══ AppBar ════════════════════════════════════════════════════════ */}
        <AppBar>
          <Brand>
            <BrandLogo>
              <AssignmentInd sx={{ color: "#6750A4", fontSize: 26 }} />
            </BrandLogo>
            <div>
              <BrandName>Resourcing Bot</BrandName>
              <BrandSub>Manager Portal</BrandSub>
            </div>
          </Brand>

          <Box display="flex" alignItems="center" gap="12px">
            <BellBtn><NotificationsIcon /></BellBtn>
            <UserPill>
              <UserAvatar>{initials}</UserAvatar>
              <div>
                <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 700, fontSize: 13, color: "#2D1B5E", lineHeight: 1.2 }}>
                  {fullName}
                </Typography>
                <Typography sx={{ fontFamily: FONT_BODY, fontWeight: 500, fontSize: 11, color: "#9B8DC4" }}>
                  Manager
                </Typography>
              </div>
            </UserPill>
          </Box>
        </AppBar>

        {/* ══ Sidebar ═══════════════════════════════════════════════════════ */}
        <Sidebar>
          {nav.map(group => (
            <SidebarSection key={group.section}>
              <SidebarSectionLabel>{group.section}</SidebarSectionLabel>
                {group.items.map(item => (
                  <NavItem
                    key={item.id}
                    $active={activeTab === item.id}
                    onClick={() => switchTab(item.id)}
                  >
                    {item.icon}{item.label}
                  </NavItem>
                ))}
              <SidebarDivider />
            </SidebarSection>
          ))}
          <NavItem onClick={handleLogout} disabled={loggingOut} style={{ marginTop: "auto" }}>
            <ExitToAppIcon />{loggingOut ? "Logging out…" : "Logout"}
          </NavItem>
        </Sidebar>

        {/* ══ Main ══════════════════════════════════════════════════════════ */}
        <Main>

          {/* ── Dashboard ───────────────────────────────────────────────── */}
          {activeTab === "dashboard" && (
            <DashPane>

              <Box mb={2.5} display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1.5}>
                <Box>
                  <Typography component="h1" sx={{ fontFamily: FONT_DISPLAY, fontWeight: 700, fontSize: TYPE.page, color: "#1a1a1a", letterSpacing: "-0.02em", lineHeight: 1.25 }}>
                    {greeting}{firstName ? `, ${firstName}` : ""}
                  </Typography>
                  <Typography sx={{ fontSize: TYPE.small, color: COLORS.muted, mt: 0.5, fontFamily: FONT_BODY }}>
                    Recruitment overview · {new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}
                  </Typography>
                </Box>

                <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1}>
                  <Box display="flex" alignItems="center" gap={1.2}>
                    <Box sx={{
                      display: "flex",
                      border: "0.5px solid rgba(103,80,164,0.20)",
                      borderRadius: `${RADIUS.sm}px`, overflow: "hidden", background: "#fff", height: 32,
                    }}>
                      {PERIODS.map(p => (
                        <Box
                          key={p.value}
                          role="button"
                          onClick={() => setPeriod(p.value)}
                          sx={{
                            px: 2, display: "flex", alignItems: "center", cursor: "pointer",
                            fontSize: 12, fontWeight: 600, fontFamily: FONT_BODY,
                            background: period === p.value
                              ? "linear-gradient(135deg,#6750A4,#4F378B)"
                              : "transparent",
                            color: period === p.value ? "#fff" : "#7A6FA0",
                            transition: "all 0.16s",
                            userSelect: "none",
                            "&:hover": { background: period === p.value ? undefined : "#F0EBF8" },
                          }}
                        >
                          {p.label}
                        </Box>
                      ))}
                    </Box>

                    <Tooltip title="Refresh">
                      <span>
                      <IconButton onClick={fetchDashboard} size="small" disabled={loading || customRangeInvalid} sx={{
                        width: 32, height: 32,
                        border: `1px solid ${COLORS.border}`, borderRadius: `${RADIUS.sm}px`,
                        bgcolor: "#fff", color: "#7A6FA0",
                        "&:hover": { bgcolor: "#EDE9F7", color: "#4F378B" },
                      }}>
                        <Refresh fontSize="small" />
                      </IconButton>
                      </span>
                    </Tooltip>
                  </Box>

                  {period === "custom" && (
                    <Box
                      display="flex" alignItems="center" gap={1.5}
                      sx={{
                        bgcolor: "#fff",
                        border: "1px solid rgba(103,80,164,0.20)",
                        borderRadius: `${RADIUS.sm}px`,
                        px: 2, py: 1,
                      }}
                    >
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6750A4", whiteSpace: "nowrap" }}>
                        From
                      </Typography>
                      <input
                        type="date"
                        value={customStart}
                        max={customEnd || undefined}
                        onChange={e => setCustomStart(e.target.value)}
                        style={dateInputStyle}
                      />
                      <Typography sx={{ fontSize: 11, color: "#9B8DC4" }}>→</Typography>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6750A4", whiteSpace: "nowrap" }}>
                        To
                      </Typography>
                      <input
                        type="date"
                        value={customEnd}
                        min={customStart || undefined}
                        onChange={e => setCustomEnd(e.target.value)}
                        style={dateInputStyle}
                      />
                      {customStart && customEnd && !customRangeInvalid && (
                        <Box sx={{
                          bgcolor: "#EDE9F7", borderRadius: "20px",
                          px: 1.2, py: 0.3,
                          fontSize: 11, fontWeight: 700, color: "#4F378B",
                          whiteSpace: "nowrap",
                        }}>
                          {Math.round((new Date(customEnd) - new Date(customStart)) / (1000 * 60 * 60 * 24))}d
                        </Box>
                      )}
                      {customRangeInvalid && (
                        <Typography sx={{ fontSize: TYPE.caption, color: COLORS.error, fontFamily: FONT_BODY }}>
                          Pick a start date on or before the end date.
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>

              {error && hasDashboardData && !loading && (
                <Alert severity="warning" sx={{ mb: 2, borderRadius: `${RADIUS.md}px` }} onClose={() => setError("")}
                  action={<Button size="small" color="inherit" onClick={fetchDashboard} sx={{ fontWeight: 600, textTransform: "none" }}>Retry</Button>}>
                  {error}
                </Alert>
              )}

              {!loading && error && !hasDashboardData ? (
                <ChartCard>
                  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={6} gap={1.5}>
                    <Typography sx={{ fontSize: TYPE.body, color: COLORS.error, fontFamily: FONT_BODY }}>{error}</Typography>
                    <Button variant="outlined" onClick={fetchDashboard}
                      sx={{ height: 36, textTransform: "none", fontWeight: 600, borderRadius: `${RADIUS.sm}px` }}>
                      Retry
                    </Button>
                  </Box>
                </ChartCard>
              ) : loading ? (
                <Box display="flex" flexDirection="column" justifyContent="center"
                  alignItems="center" minHeight="50vh" gap={2}>
                  <CircularProgress size={32} thickness={4} sx={{ color: "#6750A4" }} />
                  <Typography sx={{ fontSize: TYPE.body, color: COLORS.muted, fontFamily: FONT_BODY }}>
                    Loading dashboard…
                  </Typography>
                </Box>
              ) : (
                <>
                  {/* ── 1. RBot KPIs ──────────────────────────────────── */}
                  <SectionLabel>ResourcingBot · {currentPeriodLabel}</SectionLabel>
                  <MetricRow>
                    <MetricTile icon={<Groups />}        value={rbKpis.total}            label="Total candidates"  accentColor="#185FA5" accentBg="#E6F1FB" />
                    <MetricTile icon={<NewReleases />}   value={rbKpis.ranged_total}     label="Added this period" accentColor="#534AB7" accentBg="#EEEDFE" />
                    <MetricTile icon={<CheckCircle />}   value={rbKpis.selected}         label="Selected"          accentColor="#0F6E56" accentBg="#E1F5EE"
                      trendPct={rbKpis.total > 0 ? Math.round((rbKpis.selected / rbKpis.total) * 100) : null} trendUp />
                    <MetricTile icon={<TrendingUp />}    value={rbKpis.rejected}         label="Rejected"          accentColor="#A32D2D" accentBg="#FCEBEB"
                      trendPct={rbKpis.total > 0 ? Math.round((rbKpis.rejected / rbKpis.total) * 100) : null} trendUp={false} />
                    <MetricTile icon={<AssignmentInd />} value={rbKpis.total_recruiters} label="Active recruiters"  accentColor="#854F0B" accentBg="#FAEEDA" />
                  </MetricRow>

                  {/* ── 2. Bench + Employee KPIs ──────────────────────── */}
                  <Box display="flex" columnGap={3} flexWrap="wrap">
                    <Box flex={1} minWidth={320}>
                      <SectionLabel>Bench people</SectionLabel>
                      <MetricRow>
                        <MetricTile icon={<Engineering />}  value={benchTotal}      label="Total on bench"  accentColor="#185FA5" accentBg="#E6F1FB" />
                        <MetricTile icon={<CheckCircle />}  value={benchAvailable}  label="Available"       accentColor="#0F6E56" accentBg="#E1F5EE"
                          trendPct={benchTotal > 0 ? Math.round((benchAvailable / benchTotal) * 100) : null} trendUp />
                        <MetricTile icon={<Work />}         value={benchOnProject}  label="On project"      accentColor="#534AB7" accentBg="#EEEDFE" />
                        <MetricTile icon={<AccessTime />}   value={benchNotice + benchOther} label="Notice / other" accentColor="#854F0B" accentBg="#FAEEDA" />
                      </MetricRow>
                    </Box>
                    <Box flex={1} minWidth={320}>
                      <SectionLabel>Employees</SectionLabel>
                      <MetricRow>
                        <MetricTile icon={<SupervisorAccount />} value={empTotal}         label="Total employees"   accentColor="#534AB7" accentBg="#EEEDFE" />
                        <MetricTile icon={<CheckCircle />}       value={empActive}        label="Active"            accentColor="#0F6E56" accentBg="#E1F5EE"
                          trendPct={empTotal > 0 ? Math.round((empActive / empTotal) * 100) : null} trendUp />
                        <MetricTile icon={<Domain />}            value={empActiveClients} label="Client engage."    accentColor="#185FA5" accentBg="#E6F1FB" />
                        <MetricTile icon={<Business />}          value={empByDept.length || "—"} label="Departments" accentColor="#854F0B" accentBg="#FAEEDA" />
                      </MetricRow>
                    </Box>
                  </Box>

                  {/* ── 3. Funnel + Recruiter grouped bar ────────────── */}
                  <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={4}>
                      <ChartCard>
                        <ChartHeader>
                          <ChartTitle>Candidate flow · pipeline funnel</ChartTitle>
                          <ChartBadge>{rbKpis.total ?? 0} applied</ChartBadge>
                        </ChartHeader>
                        <ChartBody>
                          <PipelineFunnel statusCounts={rbStatusCounts} />
                        </ChartBody>
                      </ChartCard>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <ChartCard>
                        <ChartHeader>
                          <ChartTitle>Recruiter performance · selected vs rejected</ChartTitle>
                          <ChartBadge $bg="#EDE9F7" $color="#5A40A0">{currentPeriodLabel}</ChartBadge>
                        </ChartHeader>
                        <ChartBody>
                          {recruiterBarData.length === 0 ? <Empty msg="No recruiter data." /> : (
                            <ResponsiveContainer width="100%" height={250}>
                              <BarChart data={recruiterBarData} margin={{ top: 4, right: 8, left: -16, bottom: 4 }} barSize={13} barGap={2}>
                                <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.05)" vertical={false} />
                                <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#7A6FA0", fontFamily: FONT_BODY }} axisLine={false} tickLine={false} />
                                <YAxis tick={{ fontSize: 11, fill: "#B4B2A9" }} axisLine={false} tickLine={false} />
                                <RTooltip content={<CustomTooltip />} />
                                <Legend wrapperStyle={{ fontSize: 12, fontFamily: FONT_BODY, paddingTop: 8 }} />
                                <Bar dataKey="Selected" fill="#0F6E56" radius={[4,4,0,0]} />
                                <Bar dataKey="Rejected" fill="#E24B4A" radius={[4,4,0,0]} />
                                <Bar dataKey="Active"   fill="#378ADD" radius={[4,4,0,0]} />
                              </BarChart>
                            </ResponsiveContainer>
                          )}
                        </ChartBody>
                      </ChartCard>
                    </Grid>
                  </Grid>

                  {/* ── 5. Bench + Dept + Recruiter list ─────────────── */}
                  <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={4}>
                      <ChartCard>
                        <ChartHeader>
                          <ChartTitle>Bench · status breakdown</ChartTitle>
                          <ChartBadge>{benchTotal ?? 0} total</ChartBadge>
                        </ChartHeader>
                        <ChartBody>
                          {benchByStatus.length === 0 ? <Empty msg="No bench data yet." /> : (
                            [...benchByStatus].sort((a, b) => b.count - a.count).map(item => {
                              const cfg = BENCH_COLORS[item._id] ?? { c: "#5F5E5A", bg: "#F1EFE8" };
                              return (
                                <HBar key={item._id} label={item._id || "Unknown"}
                                  count={item.count} maxCount={benchMaxCount}
                                  color={cfg.c} bg={cfg.bg}
                                  pct={benchTotal > 0 ? Math.round((item.count / benchTotal) * 100) : 0} />
                              );
                            })
                          )}
                        </ChartBody>
                      </ChartCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <ChartCard>
                        <ChartHeader>
                          <ChartTitle>Employees · by department</ChartTitle>
                          <ChartBadge>{empTotal ?? 0} total</ChartBadge>
                        </ChartHeader>
                        <ChartBody>
                          {empByDept.length === 0 ? <Empty msg="No employee data yet." /> : (
                            [...empByDept].sort((a, b) => b.count - a.count).map((item, i) => (
                              <HBar key={item._id ?? i} label={item._id || "Unassigned"}
                                count={item.count} maxCount={empMaxDept}
                                color={DEPT_COLORS[i % DEPT_COLORS.length]}
                                bg={DEPT_BGS[i % DEPT_BGS.length]}
                                pct={empTotal > 0 ? Math.round((item.count / empTotal) * 100) : 0} />
                            ))
                          )}
                        </ChartBody>
                      </ChartCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <ChartCard>
                        <ChartHeader>
                          <ChartTitle>Recruiter performance list</ChartTitle>
                          <ChartBadge $bg="#EDE9F7" $color="#5A40A0">RBot</ChartBadge>
                        </ChartHeader>
                        <ChartBody>
                          {rbRecruiters.length === 0 ? <Empty msg="No recruiter data." /> : (
                            <Box display="flex" flexDirection="column" gap={1.5}>
                              {rbRecruiters.map((r, i) => {
                                const selPct = r.total > 0 ? Math.round((r.selected / r.total) * 100) : 0;
                                return (
                                  <Box key={r.recruiter_id}>
                                    <Box display="flex" alignItems="center" gap={1} mb={0.4}>
                                      <Avatar sx={{
                                        width: 24, height: 24, fontSize: 11, fontWeight: 700,
                                        bgcolor: STAGE_BGS[i % STAGE_BGS.length],
                                        color: STAGE_COLORS[i % STAGE_COLORS.length], flexShrink: 0,
                                      }}>
                                        {(r.recruiter_name || "?")[0].toUpperCase()}
                                      </Avatar>
                                      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#1a1a1a", flex: 1, fontFamily: FONT_BODY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} noWrap>
                                        {r.recruiter_name}
                                      </Typography>
                                      <Box display="flex" gap={0.6} alignItems="center" flexShrink={0}>
                                        <Typography sx={{ fontSize: 12, color: "#0F6E56", fontWeight: 700 }}>{r.selected}</Typography>
                                        <Typography sx={{ fontSize: 11, color: "#B4B2A9" }}>/{r.total}</Typography>
                                        <Chip label={`${selPct}%`} size="small" sx={{
                                          fontSize: 11, fontWeight: 700, height: 20, border: "none", "& .MuiChip-label": { fontSize: TYPE.overline, px: 0.75 },
                                          bgcolor: selPct >= 50 ? "#E1F5EE" : selPct >= 25 ? "#FAEEDA" : "#FCEBEB",
                                          color:   selPct >= 50 ? "#0F6E56" : selPct >= 25 ? "#633806" : "#791F1F",
                                        }} />
                                      </Box>
                                    </Box>
                                    <Box sx={{ height: 4, borderRadius: 99, bgcolor: STAGE_BGS[i % STAGE_BGS.length], overflow: "hidden" }}>
                                      <Box sx={{
                                        width: `${maxRbRec > 0 ? (r.selected / maxRbRec) * 100 : 0}%`,
                                        height: "100%", bgcolor: STAGE_COLORS[i % STAGE_COLORS.length],
                                        borderRadius: 99, transition: "width 0.4s ease",
                                      }} />
                                    </Box>
                                  </Box>
                                );
                              })}
                            </Box>
                          )}
                        </ChartBody>
                      </ChartCard>
                    </Grid>
                  </Grid>

                  {/* ── 6. Top active JDs ─────────────────────────────── */}
                  <ChartCard>
                    <ChartHeader>
                      <ChartTitle>Top active JDs · RBot</ChartTitle>
                      <ChartBadge>{rbJdOverall.length} shown</ChartBadge>
                    </ChartHeader>
                    <ChartBody>
                      {rbJdOverall.length === 0 ? <Empty msg="No JD data." /> : (
                        <Grid container spacing={1.2}>
                          {rbJdOverall.map((jd, i) => {
                            const selPct = jd.total > 0 ? Math.round((jd.selected / jd.total) * 100) : 0;
                            return (
                              <Grid item xs={12} sm={6} md={4} key={jd.jdID}>
                                <Box sx={{
                                  display: "flex", alignItems: "center", gap: 1.2,
                                  p: "12px 16px", borderRadius: `${RADIUS.sm}px`,
                                  border: `1px solid ${COLORS.border}`, bgcolor: COLORS.surfaceTint,
                                  "&:hover": { bgcolor: "#F3EEF9", borderColor: "rgba(103,80,164,0.14)" },
                                  transition: "all 0.14s",
                                }}>
                                  <Box sx={{
                                    width: 28, height: 28, borderRadius: `${RADIUS.sm}px`,
                                    bgcolor: STAGE_BGS[i % STAGE_BGS.length],
                                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                  }}>
                                    <Work sx={{ fontSize: 13, color: STAGE_COLORS[i % STAGE_COLORS.length] }} />
                                  </Box>
                                  <Box flex={1} minWidth={0}>
                                    <Box display="flex" alignItems="baseline" gap={0.8}>
                                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", fontFamily: FONT_BODY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} noWrap>
                                        {jd.jobRole || "—"}
                                      </Typography>
                                      <Typography sx={{ fontSize: 11, color: "#C0BDB5", fontFamily: "monospace", flexShrink: 0, whiteSpace: "nowrap" }}>
                                        {jd.jdID}
                                      </Typography>
                                    </Box>
                                    <Typography title={jd.companyName || ""} sx={{ fontSize: 11, color: "#888780", fontFamily: FONT_BODY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{jd.companyName || "—"}</Typography>
                                  </Box>
                                  <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.3} flexShrink={0}>
                                    <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#0F6E56", fontVariantNumeric: "tabular-nums" }}>
                                      {jd.selected} sel
                                    </Typography>
                                    <Typography sx={{ fontSize: 11, color: "#B4B2A9" }}>
                                      {jd.total} · {selPct}%
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      )}
                    </ChartBody>
                  </ChartCard>
                </>
              )}
            </DashPane>
          )}

          {/* ── Sub-pages (each remounts via tabRefreshKey when its nav item is clicked) ── */}
          {activeTab === "benchPeople"        && <SubPagePane><BenchPeople key={tabRefreshKey} /></SubPagePane>}
          {activeTab === "allclientanalytics" && <SubPagePane><AllClientsAnalytics key={tabRefreshKey} /></SubPagePane>}
          {activeTab === "clients" && (
            <SubPagePane>
              <ClientManagement
                key={tabRefreshKey}
                onViewJobs={handleViewClientJobs}
                onViewCandidates={handleViewClientJobs}
              />
            </SubPagePane>
          )}
          {/* RbotManagerDashboard renders its own title in its hero banner. */}
          {activeTab === "recruiterreports"   && <SubPagePane><RbotManagerDashboard key={tabRefreshKey} /></SubPagePane>}
          {activeTab === "employees"          && <SubPagePane><Employees key={tabRefreshKey} /></SubPagePane>}
          {/* Candidate Profiles: full-height three-pane browser, rendered full-bleed. */}
          {activeTab === "candidateProfiles" && (
            <CandidateBrowserPage key={tabRefreshKey} initialCompany={candidateBrowserCompany} height="calc(100vh - 68px)" />
          )}
          {activeTab === "summary" && <SubPagePane><ClientSummaryReport key={tabRefreshKey} /></SubPagePane>}

          {/* ProfileForm renders its own title and pads itself (PAGE_PADDING). */}
          {activeTab === "profile" && (
            <ProfileForm
              key={tabRefreshKey}
              userData={{
                name: fullName,
                email: user?.email || "",
                phone: user?.phone || "",
                userType: user?.userType || user?.role || "manager",
                _id: user?._id,
              }}
            />
          )}

        </Main>
      </Shell>
    </ThemeProvider>
  );
}